import dayjs from 'dayjs'

const isHourBetween = (first, last) =>
  dayjs().hour() >= first && dayjs().hour() <= last

export { isHourBetween }
